import {
    type MaybeRefOrGetter,
    toValue,
    type ComputedRef,
    computed,
} from 'vue';
import {
    type FileSizeUnit,
    type FileSizeUnitSystem,
    formatFileSize,
} from '../helpers/file-size';

export interface UseFileSizeOptions {
    unit?: MaybeRefOrGetter<FileSizeUnit>;
    system?: MaybeRefOrGetter<FileSizeUnitSystem>;
    maximumIntegerDigits?: MaybeRefOrGetter<number>;
    minimumIntegerDigits?: MaybeRefOrGetter<number>;
    maximumFractionDigits?: MaybeRefOrGetter<number>;
    minimumFractionDigits?: MaybeRefOrGetter<number>;
    maximumSignificantDigits?: MaybeRefOrGetter<number>;
    unitSeperator?: MaybeRefOrGetter<string>;
    locales?: MaybeRefOrGetter<string | string[] | undefined>;
    noUnit?: MaybeRefOrGetter<boolean>;
}

export function useFileSize(
    fileSize: MaybeRefOrGetter<number>,
    options?: UseFileSizeOptions
): ComputedRef<string>;
export function useFileSize(
    fileSize: MaybeRefOrGetter<number | null | undefined>,
    options?: UseFileSizeOptions
): ComputedRef<string | null>;
export function useFileSize(
    fileSize: MaybeRefOrGetter<number | null | undefined>,
    options: UseFileSizeOptions = {}
): ComputedRef<string | null> {
    return computed(() => {
        const fileSizeValue = toValue(fileSize);
        if (fileSizeValue === null || fileSizeValue === undefined) return null;

        return formatFileSize(fileSizeValue, {
            unit: toValue(options.unit),
            system: toValue(options.system),
            maximumIntegerDigits: toValue(options.maximumIntegerDigits),
            minimumIntegerDigits: toValue(options.minimumIntegerDigits),
            maximumFractionDigits: toValue(options.maximumFractionDigits),
            minimumFractionDigits: toValue(options.minimumFractionDigits),
            maximumSignificantDigits: toValue(options.maximumSignificantDigits),
            unitSeperator: toValue(options.unitSeperator),
            locales: toValue(options.locales),
            noUnit: toValue(options.noUnit),
        });
    });
}
